var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"sub-empresa-alertas-contratos"}},[_c('section',{staticClass:"alerta-bloco__esquerda"},[_vm._t("default")],2),_c('section',[_c('div',{staticClass:"alerta-bloco__icone",on:{"click":function($event){return _vm.ocutarAlerta()}}},[_c('i',{staticClass:"mdi mdi-close"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }